import React from 'react';
import Tooltip from '@cpg-its/ads.common.tooltip';
import { Hidden } from '@material-ui/core';
import { tcsmColors } from '../../../../../global/constants/theme/theme-constants/colors';

interface PaymentItemViewProps {
    title?: string,
    label: string,
    current: string,
    tooltip?: string
    next: string
}
export const PaymentItemView = (props: PaymentItemViewProps) => {

    const dataDisplay = (current: string, next: string) => {
        return <>
            <div className='paginated-table-row-cell paginated-table-row-cell-value'>
                <p>{current}</p>
            </div>
            {
                next ? <div className='paginated-table-row-cell paginated-table-row-cell-value'><p>{next}</p> </div> : null
            }
        </>;

    };

    return (
        <>
            { props.title ? <div className='paginated-table-row'><div className='paginated-table-row-cell'><h3>{props.title}</h3></div></div> : null}
            <Hidden xsDown>
                <div className='paginated-table-row'>
                    <div className='paginated-table-row-cell paginated-table-row-cell-header'>

                        <p className='input-label'>{props.label}</p>
                        <div className='row-tooltip'>
                            {props.tooltip ? <Tooltip iconColor={tcsmColors.blue}  title={props.tooltip} /> : null}
                        </div>

                    </div>
                    {dataDisplay(props?.current, props?.next)}
                </div>
            </Hidden>
            <Hidden smUp>
                <div className='paginated-table-row paginated-table-row-mobile'> 
                    <div className='paginated-table-row-cell-header-mobile'>
                        <p className='input-label'>{props.label}</p>

                        {props.tooltip ? <div className='row-tooltip'> <Tooltip iconColor={tcsmColors.blue} title={props.tooltip} /> </div> : null}
                        
                    </div>
                    <p>{props.current}</p>
                </div>
            </Hidden>
        </>
    );
};

PaymentItemView.defaultProps =
{
    tooltip: null,
    title: null,
};